import React, { useState } from "react";
import { Button } from "../../components/ButtonUtils";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { ImageKitUpload } from "../../../ui/ImageKitLibrary";

const ExteriorImages = ({ showModal, onClick, exteriorImages, setExteriorImages }) => {
  if (!showModal) return null;

  const addImageSlot = () =>
    setExteriorImages([
      ...exteriorImages,
      { thumbnail: null, image_cdn_id: null },
    ]);

  return (
    <div className="fixed inset-0 z-[150]">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/50"
        onClick={onClick}
        aria-hidden="true"
      />

      {/* Dialog */}
      <div
        className="relative mx-auto flex h-full w-full max-w-5xl items-center justify-center p-3"
        role="dialog"
        aria-modal="true"
        aria-labelledby="ext-images-title"
      >
        <div className="relative flex h-[90vh] w-full flex-col overflow-hidden rounded-2xl bg-white shadow-xl">
          {/* Header */}
          <div className="flex items-center justify-between border-b px-4 py-3">
            <div className="flex items-baseline gap-2">
              <h2 id="ext-images-title" className="text-base font-semibold">
                Interior / Exterior Images
              </h2>
              <span className="text-xs text-slate-500">
                {exteriorImages?.length || 0} item(s)
              </span>
            </div>

            <div className="flex items-center gap-2">
              <Button
                props={{
                  type: "button",
                  title: "Add Image",
                  category: "orange",
                  action: "add",
                  onClick: addImageSlot,
                }}
              />
              <button
                type="button"
                onClick={onClick}
                className="inline-flex h-8 w-8 items-center justify-center rounded-md hover:bg-slate-100"
                aria-label="Close"
                title="Close"
              >
                <svg viewBox="0 0 20 20" className="h-4 w-4" fill="currentColor">
                  <path
                    fillRule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </div>
          </div>

          {/* Body */}
          <div className="flex-1 overflow-y-auto p-4">
            {exteriorImages?.length ? (
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                {exteriorImages.map((_, idx) => (
                  <ImageWidget
                    key={idx}
                    index={idx}
                    menu={exteriorImages}
                    setMenu={setExteriorImages}
                  />
                ))}
              </div>
            ) : (
              <div className="flex h-full min-h-[240px] flex-col items-center justify-center rounded-lg border border-dashed border-slate-300 p-6 text-center">
                <p className="mb-3 text-sm font-medium text-slate-700">
                  No images yet
                </p>
                <p className="mb-4 text-xs text-slate-500">
                  Add interior or exterior images for this place.
                </p>
                <Button
                  props={{
                    type: "button",
                    title: "Add First Image",
                    category: "orange",
                    action: "add",
                    onClick: addImageSlot,
                  }}
                />
              </div>
            )}
          </div>

          {/* Footer */}
          <div className="flex items-center justify-between border-t px-4 py-3">
            <div className="text-xs text-slate-500">
              Tip: You can add multiple images; each upload updates the list instantly.
            </div>
            <div className="flex items-center gap-2">
              <Button
                props={{
                  type: "button",
                  title: "Add Image",
                  category: "orange",
                  action: "add",
                  onClick: addImageSlot,
                }}
              />
              <Button
                props={{
                  type: "button",
                  title: "Done",
                  category: "default",
                  action: "default",
                  onClick,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExteriorImages;

/* Helpers */
const removeExtImage = ({ menu, setMenu, index }) => {
  const data = menu?.filter((_, i) => i !== index);
  setMenu([...data]);
};

const ImageWidget = ({ index, setMenu, menu }) => {
  const [thumbnail, setThumbnail] = useState(
    menu[index]?.thumbnail ? menu[index]?.thumbnail : null
  );
  const [thumbnailId, setThumbnailId] = useState(
    menu[index]?.image_cdn_id ? menu[index]?.image_cdn_id : null
  );

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-3 shadow-sm">
      <div className="mb-3 flex items-center justify-between">
        <p className="text-xs font-semibold">Image #{index + 1}</p>
        <Button
          props={{
            type: "button",
            title: `Remove`,
            category: "red",
            action: "",
            onClick: () => removeExtImage({ setMenu, menu, index }),
          }}
        />
      </div>

      <div className="rounded-lg bg-slate-50 p-3">
        <ImageKitUpload
          thumbnail={thumbnail}
          thumbnailId={thumbnailId}
          setThumbnail={setThumbnail}
          setThumbnailId={setThumbnailId}
          folder={image_kit_folder("dosee/", FOLDERS.RESTAURANTS)}
          isRestaurantModal={true}
          onSuccess={(url, id) => {
            const next = menu.map((x) => x);
            next[index] = { thumbnail: url, image_cdn_id: id };
            setMenu(next);
          }}
        />
      </div>
    </div>
  );
};
